import { safeDivide, formatNumber, formatNumberToLabel } from '@/helpers/numberHelpers';

// A page that always carries ?toCurrencyUid gets it from the URL; a view embedded in a
// page that doesn't falls back to the company's default currency.
const getToCurrencyUidOrDefault = (searchParamCurrencyUid, defaultCurrencyUid) => searchParamCurrencyUid || defaultCurrencyUid;

// `decimals` defaults to the currency's own precision; pass 0 for whole amounts.
const formatCurrencyValue = (value, currency, decimals = currency.decimals) => {
  return `${currency.symbol}${formatNumber(value, decimals)}`;
};

const convertCurrency = (value = 0, baseCurrency, toCurrency) => {
  return value * safeDivide(toCurrency.rate, baseCurrency.rate);
};

const formatCurrency = (value = 0, baseCurrency, toCurrency) => {
  if (!toCurrency) {
    return formatCurrencyValue(value, baseCurrency);
  }

  const convertedValue = convertCurrency(value, baseCurrency, toCurrency);
  return formatCurrencyValue(convertedValue, toCurrency);
};

const formatCompactCurrency = (value = 0, baseCurrency, toCurrency) => {
  const currency = toCurrency || baseCurrency;
  const convertedValue = toCurrency ? convertCurrency(value, baseCurrency, toCurrency) : value;
  return `${currency.symbol}${formatNumberToLabel(convertedValue)}`;
};

export { convertCurrency, formatCurrency, formatCurrencyValue, formatCompactCurrency, getToCurrencyUidOrDefault };
